import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingFallback = ({ message = 'Loading...' }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight={200}
      p={3}
    >
      <CircularProgress size={40} thickness={4} />
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mt: 2 }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingFallback;
